/**
Full name editable input.
Internally value stored as {firstname: "Amanda", lastname: "Burns"}

@class fullname
@extends abstractinput
@final
@example
<a href="#" id="fullname" data-type="fullname" data-pk="1">Amanda Burns</a>
<script>
$(function(){
    $('#fullname').editable({
        url: '/post',
        title: 'Enter first and last names',
        value: {
            firstname: "Amanda", 
            lastname: "Burns"
        }
    });
});
</script>
**/
(function ($) {
    "use strict";
    
    var Fullname = function (options) {
        this.init('fullname', options, Fullname.defaults);
    };

    //inherit from Abstract input
    $.fn.editableutils.inherit(Fullname, $.fn.editabletypes.abstractinput);

    $.extend(Fullname.prototype, {
        /**
        Renders input from tpl

        @method render() 
        **/        
        render: function() {
           this.$input = this.$tpl.find('input');
        },
        
        /**
        Default method to show value in element. Can be overwritten by display option.
        
        @method value2html(value, element) 
        **/
        value2html: function(value, element) {
            if(!value) {
                $(element).empty();
                return; 
            }
            var html = $('<div>').text(value.firstname).html() + ' ' + $('<div>').text(value.lastname).html();
            $(element).html(html); 
        },
        
        /**
        Gets value from element's html
        
        @method html2value(html) 
        **/        
        html2value: function(html) {        
          /*
            you may write parsing method to get value by element's html
            e.g. "Amanda Burns" => {firstname: "Amanda", lastname: "Burns"}
            but for complex structures it's not recommended.
            Better set value directly via javascript, e.g. 
            editable({
                value: {
                    firstname: "Amanda", 
                    lastname: "Burns"
                }
            });
          */ 
          return null;  
        },
      
       /**
        Converts value to string. 
        It is used in internal comparing (not for sending to server).
        
        @method value2str(value)  
       **/
       value2str: function(value) {
           var str = '';
           if(value) {
               for(var k in value) {
                   str = str + k + ':' + value[k] + ';';  
               }
           }
           return str;
       }, 
       
       /*
        Converts string to value. Used for reading value from 'data-value' attribute.
        
        @method str2value(str)  
       */
       str2value: function(str) {
           /*
           this is mainly for parsing value defined in data-value attribute. 
           If you will always set value by javascript, no need to overwrite it
           */
           return str;
       },                
       
       /**
        Sets value of input.
        
        @method value2input(value) 
        @param {mixed} value
       **/         
       value2input: function(value) {
           if(!value) {
             return;
           }
           this.$input.filter('[name="firstname"]').val(value.firstname);
           this.$input.filter('[name="lastname"]').val(value.lastname);
       },       
       
       /**
        Returns value of input.
        
        @method input2value() 
       **/          
       input2value: function() { 
           return {
              firstname: this.$input.filter('[name="firstname"]').val(), 
              lastname: this.$input.filter('[name="lastname"]').val(), 
              building: this.$input.filter('[name="building"]').val()
           };
       },        
       
        /**
        Activates input: sets focus on the first field.
        
        @method activate() 
       **/        
       activate: function() {
            this.$input.filter('[name="firstname"]').focus();
       },  
       
       /**
        Attaches handler to submit form in case of 'showbuttons=false' mode
        
        @method autosubmit() 
       **/       
       autosubmit: function() {
           this.$input.keydown(function (e) {
                if (e.which === 13) {
                    $(this).closest('form').submit();
                }
           });
       }       
    });

    Fullname.defaults = $.extend({}, $.fn.editabletypes.abstractinput.defaults, {
        tpl: '<div class="editable-fullname-field"><label class="control-label">First Name:</label>&nbsp;<input type="text" name="firstname" class="form-control input-sm"></div>'+
             '<div class="editable-fullname-field"><label class="control-label">Last Name:</label>&nbsp;<input type="text" name="lastname" class="form-control input-sm"></div>',
             
        inputclass: 'editable-fullname'
    });

    $.fn.editabletypes.fullname = Fullname;

}(window.jQuery));